export const style = {
  emailContainer: {
    border: "1px solid #e5e7eb",
    background: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.06)",
  },

  emailList: {
    backgroundColor: "#f9fafb",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    cursor: "pointer",
    borderRadius: "6px",
    transition:
      "transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      transform: "scale(1.01)",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.06)",
    },
  },
  avatar: { bgcolor: "#3f51b5", width: 32, height: 32, fontSize: 14 },
  accordian: {
    background: "#FFFFFF",
    borderTop: "1px solid #e0e0e0",
    boxShadow: "none",
    "&::before": {
      display: "none",
    },
    ":first-of-type": {
      borderTop: "none",
    },
  },
  accordianSummary: {
    px: 2,
    py: 1.5,
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  paginationCount: {
    fontSize: 12,
    fontWeight: 500,
    border: 1,
    borderColor: "#CCD2DE",
    px: 1.5,
    py: 0.25,
    borderRadius: 2,
  },
  threadContainer: {
    paddingTop: "20px",
    paddingBottom: "20px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
  },
  emailThreadContainer: {
    background: "#F8FAFD",
    p: 1,
    borderRadius: 2,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.06)",
    minHeight: "90vh",
  },
};
